import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    Grid,
    Card,
    CardContent,
    CardActions,
    Button,
    Typography,
    makeStyles
} from '@material-ui/core'

import ListagemContato from '../ListagemContato';

const useStyles = makeStyles(theme => ({
    titulo: {
        color: theme.palette.primary.main
    },
    subtitulo: {
        color: theme.palette.text.primary,
        marginTop: theme.spacing(2)
    },
    texto: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1)
    },
    root: {
        width: '100vw',
        height: '100vh'
    },
    actions: {
        justifyContent: 'center'
    },
    button: {
        color: theme.palette.primary.main
    }
}));

function NotFoundPage(
    {
        history
    }
) {
    const classes = useStyles();

    const irParaPaginaHome = () => {
        history.push('/');
    }

    return (
        <Grid container
            className={classes.root}
            justify='center'
            alignItems='center'>
            <Grid item>
                <Card>
                    <CardContent>
                        <Typography variant='h2'
                            className={classes.titulo}>
                            Ops! <span aria-hidden="true" role="img">😕</span>
                        </Typography>
                        <Typography variant='h5'
                            className={classes.subtitulo}>
                            Página não encontrada! Ela pode ter sido removida ou você digitou o endereço incorretamente.
                        </Typography>
                        <Typography variant='body2'
                            className={classes.texto}>
                            Também estamos disponíveis para atendê-lo nos canais abaixo:
                        </Typography>
                        <ListagemContato />
                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Button variant="contained"
                            className={classes.button}
                            onClick={irParaPaginaHome}
                            color='secondary'>Voltar para a Home</Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    );
}

export default withRouter(NotFoundPage);